module.exports = __webpack_public_path__ + "assets/c31c0d2a13f4ab8741c4be7b10f444b8.mp3";